import React, { useState } from "react";

import { InputGroup, Label, Button, Intent, Checkbox } from "@blueprintjs/core";
import api from "../common/lib/api";
import Errors, { useError } from "../common/components/Errors";
import { Redirect } from "react-router-dom";
import formFieldHelper from "../form/formFieldHelper";
import PasswordInput from "../form/PasswordInput";
import { saveSession } from "../helpers/session";

export default function Page() {
  const { errors, setErrors } = useError();
  const [state, setState] = useState({
    email: '',
    password: '',
    stayLoggedIn: false
  });
  const [redirect, setRedirect] = useState(false);

  const formField = formFieldHelper(state, setState);

  async function submit() {
    setErrors([]);
    const { data } = await api.post("/login", state, {
      validateStatus: () => true,
    });
    if (data.errors) {
      setErrors(data.errors);
      return;
    }
    if (data.token) {
      const id = Date.now().toString(36).substring(2);
      saveSession(id, {
        id,
        token: data.token,
        email: state.email,
        stayLoggedIn: state.stayLoggedIn,
      });
      setRedirect('/web/session/' + id);
    }
  }

  if (redirect) {
    return <Redirect to={redirect} />
  }

  return (
    <>
      <h1>Log In</h1>
      <form onSubmit={e => {
        e.preventDefault();
        submit();
      }}>
        <Label>
          Please enter your email address:
          <InputGroup
            placeholder="e.g. fred@nerk.com"
            type="email"
            required
            {...formField('email')}
          />
        </Label>
        <Label>
          Please enter your email password:
          <PasswordInput
            required
            {...formField('password')}
          />
        </Label>
        <Label>
          <Checkbox
            label="Stay Logged In"
            {...formField('stayLoggedIn', 'checked')}
          />
        </Label>
        <Errors.Callout errors={errors} setErrors={errors} />
        <Button type="submit" intent={Intent.SUCCESS}>
          Log In
        </Button>
      </form>
    </>
  );
};


